import QAServiceDetail from "../views/QAService/QAServiceDetail";
import SIServiceDetail from "../views/SIService/SIServiceDetail";
import PVSMIPServiceDetail from "../views/PVSMIPService/PVSMIPServiceDetail";
import ESSSMIPServiceDetail from "../views/ESSSMIPService/ESSSMIPServiceDetail";
import EBRMaterialsServiceDetail from "../views/EBRMaterialsService/EBRMaterialsServiceDetail";
import PVPFTServiceDetail from "../views/PVPFTService/PVPFTServiceDetail";
import EBRServiceDetail from "../views/EBRService/EBRServiceDetail";
import SCMServiceDetail from "../views/SCMService/SCMServiceDetail/SCMServiceDetail";
import CRMIServiceDetail from "../views/CRMIService/CRMIServiceDetail/CRMIServiceDetail";
import ESSPFRServiceDetail from "../views/ESSPFRService/ESSPFRServiceDetail";
import ESSSTPRServiceDetail from "../views/ESSSTPRService/ESSSTPRServiceDetail";
import PVSTPRServiceDetail from "../views/PVSTPRService/PVSTPRServiceDetail";
import ELInspectionsServiceDetail from "../views/ELInspectionsService/ELInspectionsServiceDetail";
import ESGTServiceDetail from "../views/ESGTService/ESGTServiceDetail";
import WebinarsServiceDetail from "../views/WebinarsService/WebinarsServiceDetail";

const servicesMap = {
  qa: (props) => <QAServiceDetail {...props} />,
  si: (props) => <SIServiceDetail {...props} />,
  pvSmip: (props) => <PVSMIPServiceDetail {...props} />,
  essSmip: (props) => <ESSSMIPServiceDetail {...props} />,
  ebrMaterials: (props) => <EBRMaterialsServiceDetail {...props} />,
  pvPft: (props) => <PVPFTServiceDetail {...props} />,
  ebr: (props) => <EBRServiceDetail {...props} />,
  scm: (props) => <SCMServiceDetail {...props} />,
  customReportsMi: (props) => <CRMIServiceDetail {...props} />,
  essPfr: (props) => <ESSPFRServiceDetail {...props} />,
  essStpr: (props) => <ESSSTPRServiceDetail {...props} />,
  pvStpr: (props) => <PVSTPRServiceDetail {...props} />,
  elInspections: (props) => <ELInspectionsServiceDetail {...props} />,
  esgt: (props) => <ESGTServiceDetail {...props} />,
  webinars: (props) => <WebinarsServiceDetail {...props} />,
};

export default servicesMap;
